import { t } from 'i18next';
import CheckIcon from '../../../../components/icons/CheckIcon';

interface ToggleAllCardsButtonProps {
  photoCards: Array<{
    photoCardId: string;
    memberId: string;
    collectedCount: number;
  }>;
  selectedCollectedData: Record<string, Record<string, { collectedCount: number }>>;
  currentMember: { memberId: string } | null;
  onToggleAll: (
    photoCards: Array<{
      photoCardId: string;
      memberId: string;
      collectedCount: number;
    }>,
    isSelect: boolean
  ) => void;
}

const ToggleAllCardsButton = ({
  photoCards,
  selectedCollectedData,
  currentMember,
  onToggleAll
}: ToggleAllCardsButtonProps) => {
  if (!currentMember || !photoCards.length) return null;

  // 현재 멤버의 카드들 중 선택된 카드 수 계산
  const selectedCount = photoCards.reduce((count, card) => {
    if (selectedCollectedData[currentMember.memberId]?.[card.photoCardId]) {
      return count + 1;
    }
    return count;
  }, 0);

  const isAllSelected = selectedCount === photoCards.length;

  const handleToggleAll = () => {
    // 전체 선택되어 있을 때만 전체 해제, 그 외에는 항상 전체 선택
    onToggleAll(photoCards, !isAllSelected);
  };

  return (
    <button
      type="button"
      className="flex gap-[2.5px] items-center shrink-0"
      onClick={handleToggleAll}
    >
      <div
        className={`rounded-full flex items-center justify-center p-[3px] m-[2.5px] ${
          isAllSelected
            ? 'bg-primary-light dark:bg-primary-dark'
            : 'bg-surface-lightLv2 dark:bg-surface-darkLv2'
        }`}
      >
        <CheckIcon
          width={'9px'}
          height={'9px'}
          className={`
            ${isAllSelected ? 'fill-onPrimary' : 'fill-sub-light-2 dark:fill-sub-dark-2'}
          `}
        />
      </div>
      <span className="text-main-light-3 dark:text-main-dark-3 leading-none text-[13px]">
        {t('entire')}
      </span>
    </button>
  );
};

export default ToggleAllCardsButton;
